import { loadScript } from '@/utils/loadScript'

import {
    AdSenseAdBreakFunctionForH5Game,
    AdSenseAdBreakFunctionParam,
    AdSenseAdConfigFunctionForH5Game,
    AdSenseAdConfigFunctionParam,
} from './AdSenseAdBreak'
import { AdSenseWindow } from './AdSenseWindow'
import { AD_BREAK_MAXIMUM_FREQUENCY_RATE, AD_SENSE_CLIENT_ID } from './constants'

export type AdSenseScriptFunctions = {
    adBreak: AdSenseAdBreakFunctionForH5Game
    adConfig: AdSenseAdConfigFunctionForH5Game
}

const AS_SENSE_LOAD_SCRIPT_TIMEOUT_MS = 3_000

export function loadAdSenseScript(): Promise<AdSenseScriptFunctions> {
    const loadScriptPromise = loadScript({
        src: `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js`,
        timeoutMs: AS_SENSE_LOAD_SCRIPT_TIMEOUT_MS,
        onBeforeFirstLoad: (script) => {
            script.crossOrigin = 'anonymous'

            script.setAttribute('data-ad-client', AD_SENSE_CLIENT_ID)
            script.setAttribute('data-ad-frequency-hint', AD_BREAK_MAXIMUM_FREQUENCY_RATE)

            script.async = true
        },
    })

    return loadScriptPromise.then(() => {
        const { adsbygoogle } = document.defaultView as AdSenseWindow

        if (!adsbygoogle) {
            throw new Error('adsbygoogle is not defined')
        }

        return {
            adBreak: (o: AdSenseAdBreakFunctionParam) => {
                adsbygoogle.push(o)
            },
            adConfig: (o: AdSenseAdConfigFunctionParam) => {
                adsbygoogle.push(o)
            },
        }
    })
}
